import {FC} from 'react'

export const ToolbarResource: FC = () => {
  return <></>
}
